import { render, staticRenderFns } from "./stereoscopicHistogram3.vue?vue&type=template&id=2f9d7d8f"
import script from "./stereoscopicHistogram3.vue?vue&type=script&lang=js"
export * from "./stereoscopicHistogram3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports